import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, PrimeNGConfig } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { OutrasReceitas } from 'src/app/admihair/api/dto/outras-receitas';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OutrasReceitasService } from 'src/app/admihair/service/outras-receitas.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-outras-receitas-inserir',
  templateUrl: './outras-receitas-inserir.component.html',
  styleUrls: ['./outras-receitas-inserir.component.scss']
})
export class OutrasReceitasInserirComponent implements OnInit {

  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  progressoRequisicao: boolean = false;

  tiposPagamento: TipoPagamento[] = [];
  planosContaEmpresa: PlanoContaEmpresa[] = [];

  constructor(private outrasReceitasService: OutrasReceitasService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private tipoPagamentoService: TipoPagamentoService,
    private utilStorageService: UtilStorageService,
    private primengConfig: PrimeNGConfig,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;
  value?: string;

  ngOnInit(): void {
    this.permissaoInserir = AuthUtil.verificarPermissao('PERM_INSERIR_OUTRAS_RECEITAS');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.buscarTiposPagamento();
      this.buscarPlanosConta();
    }
  }

  salvar() {
    this.progressoRequisicao = true;
    const outrasReceitas: OutrasReceitas = this.form?.value;
    outrasReceitas.empresaId = this.empresaSelecionada?.id;
    outrasReceitas.operador = this.utilStorageService.getUser().usuario.id;
    this.outrasReceitasService.salvar(outrasReceitas).subscribe({
      next: (data: OutrasReceitas) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  buscarPlanosConta() {
    const codigos: number[] = [6, 9, 20, 54];
    this.planoContaEmpresaService.listarPorEmpresaECodigo(this.empresaSelecionada?.id, codigos).subscribe({
      next: (data: PlanoContaEmpresa[]) => {
        this.planosContaEmpresa = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }
  buscarTiposPagamento() {
    this.tipoPagamentoService.listarPorEmpresaEOperacaoInterno(this.empresaSelecionada?.id).subscribe({
      next: (data: TipoPagamento[]) => {
        this.tiposPagamento = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  limparFormulario() {
    this.form?.reset();
  }

  ocultarMensagem() {
    this.messagemVisivel = false;
  }

}
